import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { SubscriptionSearchResult } from "../types/subscriptionSearch";

export const searchSubscriptions = async (config: {
  "app-id": string;
  search: string;
}): Promise<SubscriptionSearchResult[]> => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
(datastore Qo.Public.Api.Sub "omega/query-omega/public/api/subscription")
(= Input ${ednString})
(Qo.Public.Api.Sub/subscription-search Input Response)
(return [Response])
`;
  return queryOmegaSingleResult(query);
};
